import { Injectable } from '@tanbo/vue-di-plugin';

@Injectable()
export class ConfigService {
  constructor() {
  }

  getUserProtocolUrl = 'https://act.cmcmcdn.com/keniu/agreement/keniupptagreement.html'
  getPrivacyPolicyUrl = 'http://act.cmcmcdn.com/keniu/agreement/keniubangong-privacy.html'
}
